import jwtDecode from "jwt-decode";
import { JwtPayload } from "jsonwebtoken";

export const randomizeEmail = (original: String) => {  
  let arrobaIndex = original.indexOf("@");
  let nome = original.substring(0,arrobaIndex)
  nome = nome.substring(0,3) + ("*").repeat(nome.length - 3);
  return nome + "@" + original.substring(arrobaIndex+1);
}

export const isJwtExpired = (token: string) => {
  if (typeof(token) !== 'string' || !token) return true;  
  let isJwtExpired = false;
  const decoded = jwtDecode<JwtPayload>(token);  
  const currentTime = new Date().getTime() / 1000;
  if (decoded.exp && currentTime > decoded.exp) isJwtExpired = true;
  return isJwtExpired;
}

export const GetItemProp = (
  item: { [key: string]: any } | undefined,
  fieldName: string
) => {
  if (item === null || item === undefined) return "";
  var SplitedField = fieldName.split(".");

  var object = item;
  for (var i = 0; i < SplitedField.length; i++) {
    var currentField =
      SplitedField[i].slice(0, 1).toLowerCase() +
      SplitedField[i].slice(1, SplitedField[i].length);
    if (i === SplitedField.length - 1) {
      if (object !== null && object !== undefined) return object[currentField];
    } else {
      if (object !== null && object !== undefined)
        object = object[currentField];
    }
  }
};

export const SetItemProp = (
  item: { [key: string]: any } | undefined,
  fieldName: string,
  value: any
) => {
  if (item === null || item === undefined) return "";
  var SplitedField = fieldName.split(".");
  var object = item;
  for (var i = 0; i < SplitedField.length; i++) {

    var currentField =
      SplitedField[i].slice(0, 1).toLowerCase() +
      SplitedField[i].slice(1, SplitedField[i].length);

    if (i === SplitedField.length - 1) {
      if (object !== null && object !== undefined) {
        object[currentField] = value
        return object;
      }
    } 
    else {
      if (object !== null && object !== undefined)
      object = object[currentField];
    }
  }
};

export const setEnterAsTab = () => {
  document.addEventListener('keydown', function (event: any) {
    if (event.keyCode === 13 && event.target.nodeName === 'INPUT') {
      var form = event.target.form;
      var index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  });
};

export const fillString = (original: String) => {  
  let modificado = original === null || original === undefined ? '' : original;
  return modificado;
};